import type { ActDirector } from "../acts/ActDirector";
import {
  aimedShot,
  ringBurst,
  sweepBar,
  wallWithGap,
  type BulletEvent,
} from "./patterns";

export class Spawner {
  private cooldown = 0.8;
  private phase = 0;
  private width: number;
  private height: number;

  constructor(width: number, height: number) {
    this.width = width;
    this.height = height;
  }

  setSize(w: number, h: number): void {
    this.width = w;
    this.height = h;
  }

  update(
    dt: number,
    act: ActDirector,
    shipX: number,
    shipY: number,
  ): BulletEvent[] {
    this.cooldown -= dt;
    if (this.cooldown > 0) return [];

    const density = act.density;
    const base = 1.1 / density;
    this.cooldown = base * (0.75 + Math.random() * 0.5);
    this.phase += 0.4;

    const events: BulletEvent[] = [];
    const id = act.current.id;
    const cx = this.width * (0.2 + Math.random() * 0.6);
    const cy = this.height * 0.12;

    if (id === 1) {
      events.push(aimedShot(cx, cy, shipX, shipY, 140 + act.intensity * 40));
      if (Math.random() < 0.35) {
        events.push(
          ...ringBurst(cx, cy + 20, 6, 90, this.phase).map((e) => ({
            ...e,
            vy: Math.abs(e.vy) * 0.4 + 70,
          })),
        );
      }
    } else if (id === 2) {
      events.push(
        ...ringBurst(cx, cy, 10, 110 + act.intensity * 30, this.phase),
      );
      events.push(aimedShot(this.width - cx, cy, shipX, shipY, 160));
    } else if (id === 3) {
      events.push(
        ...sweepBar(cy, this.width, 7, 130, Math.random() > 0.5 ? 1 : -1),
      );
      events.push(...ringBurst(shipX, cy, 8, 100, this.phase));
    } else if (id === 4) {
      const gap = shipX + (Math.random() - 0.5) * 40;
      events.push(
        ...wallWithGap(cy, this.width, gap, 70, 28, 150 + act.intensity * 40),
      );
      events.push(aimedShot(cx, cy, shipX, shipY, 180));
    } else {
      events.push(...ringBurst(this.width / 2, cy, 14, 130, this.phase));
      events.push(...wallWithGap(cy + 40, this.width, shipX, 55, 24, 170));
      events.push(aimedShot(cx, cy, shipX, shipY, 200));
    }

    return events;
  }
}
